import React, { Component, Fragment } from 'react';
import className from 'classnames';
import { Link } from 'react-router-dom';
import { ReactComponent as HomeIcon } from './icons/home.svg';
import { ReactComponent as ListIcon } from './icons/list.svg';
import { getCompanyType, deleteToken, getIsSettingsVisible, getIsApprover, setCookie, getUser } from 'Utils/storage';
import { SEEKER_VALUE, SHOW_SIDEBAR, MODULE_ERROR_ACCESS, VOLTAS_MIS, RIL_MIS, LEGRAND_MIS, HIKAL, DEEPAK_PHENOLICS, GREEN_PLY, PROVIDER_VALUE, EMAMI, CARGIL, CENTURY_PLY, ROQUETTE, KRBL, BEAM, PARAMOUNT, STAR_CEMENT, PANTALOONS, ARDEX, GODREJ, BHIWANDI_CYLINDERS, FORSOC, RIL_RETAIL, FINE_TECH, RELIANCE_BRANDS, POLYCAB, ADM_AGRO_LATUR_VIZAG, ADM_AGRO, GALAXY_SURFACE, RAJPETRO, TTBIL, KNAUF, DALMIA_CEMENT, MAHINDRA_SUMMIT, BAJAJ_ELECTRICALS, MUNDRA_SOLAR, FRESENIUS_KABI, ABFRL, DEEPAK_PHENOLICS_SAP, BACARDI, COROMANDEL, VISHAKA, CONTRACTING_MODULE_ID } from 'Constants/commonConstants';
import { //ACCOUNTS_URL, INDENT_URL,
        LCL_URL, SEEKER_ACCOUNTS_URL, PROVIDER_ACCOUNTS_URL, SEEKER_INDENT_URL, PROVIDER_INDENT_URL, logOutWithToken } from 'Utils/api';
import ReactTooltip from 'react-tooltip';
import { isAdaniWilmar } from 'Utils/';
import { withRouter } from 'react-router';
import { isAbfrl, isBacardi, isBeamS, isCoromandel, isDesmet, isDesmetSupplier, isEmami, isFineTech, isFosroc, isHikal, isMITSUI, isSapDPL } from 'Utils/index';
import SiderBarElementT1 from './SiderBarElementT1';
import { getItemFromLocal } from 'Utils/localStorage';
import { SAVE_USER_REPORT_UTILIZATION_EVENT, GET_COMPANY_DATA, GET_DAAI_CONFIG } from 'Constants/actionConstants';
import { connect } from 'react-redux';

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.user = getUser();
        this.state = {
            openSourcing: this.user.contracting ? true : false,
            openContracting: false,
            openIndenting: false,
            openSettings: false,
            openReports: false,
            openDashboards: false,
            openApprovals: false,
            openUploadPlan: false,
            companyData: null,
            DaaiReports: [],

        }
        this.collapseToggle = this.collapseToggle.bind(this);
    }

    componentDidMount() {
            this.getCompanyData();
        // this.getDaaiReportsAndDashboardsConfig();
    }

    // getDaaiReportsAndDashboardsConfig = () => {
    //     const { dispatch } = this.props;

    //     dispatch({
    //         type: GET_DAAI_CONFIG,
    //         params: {
    //             module: 'Contracting',
    //             companyId: this.user.companyId,
    //         },
    //         onSuccess: (responseData) => {
    //             this.setState({ DaaiReports: responseData?.reports || [] });
    //         }
    //     });
    // }

    getCompanyData = () => {
        const { dispatch } = this.props;
        const isSeeker = getCompanyType() === SEEKER_VALUE;
        const seekerCompanyId = isSeeker
            ? this.user.companyId
            : getItemFromLocal('transporter_seeker_company_id');

        dispatch({
            type: GET_COMPANY_DATA,
            isSeeker,
            params: {
                module: 'Contracting',
                module_id: CONTRACTING_MODULE_ID,
                companyId: this.user.companyId,
                seekerCompanyId,
            },
            onSuccess: (responseData) => {
               this.setState({ DaaiReports: responseData?.reports || [] });
            }
        });
    }

    collapseToggle(which) {
        if (which == "contracting" && this.user.contracting) {
            this.setState({ openContracting: !this.state.openContracting });
        } else if (which === 'indenting' && this.user.indenting) {
            this.setState({ openIndenting: !this.state.openIndenting });
        } else if (which === 'settings' && this.user.contracting) {
            this.setState({ openSettings: !this.state.openSettings });
        } else if (which === 'sourcing' && this.user.contracting) {
            this.setState({ openSourcing: !this.state.openSourcing });
        } else if (which === 'reports') {
            this.setState({ openReports: !this.state.openReports });
        } else if (which === 'dashboards') {
            this.setState({ openDashboards: !this.state.openDashboards });
        } else if (which === 'approval') {
            this.setState({ openApprovals: !this.state.openApprovals });
        } else if (which === 'uploadPlan') {
            this.setState({ openUploadPlan: !this.state.openUploadPlan });
        }
    }
    logout = () => {
        // deleteToken();
        //localStorage.setItem('termsAndConditionsAccepted', false);
        // location.href="/";
        logOutWithToken();
    }
    handleAccountsRedirect = (type) => {
        const hostName = window.location.hostname;
        const companyType = getCompanyType();

        const USER_PERMISSIONS = { accounts: this.user.accounts, indents: this.user.indenting };
        if (!USER_PERMISSIONS[type]) return;

        // CIL path — *.sclenai.coromandel.biz always redirects within that domain
        if (hostName.endsWith('sclenai.coromandel.biz')) {
            const CIL_MODULE_SUBDOMAINS = { accounts: 'accounts', indents: 'indenting' };
            const subdomain = CIL_MODULE_SUBDOMAINS[type];
            if (subdomain) {
                const base = hostName.endsWith('beta.sclenai.coromandel.biz')
                    ? 'beta.sclenai.coromandel.biz'
                    : 'sclenai.coromandel.biz';
                localStorage.setItem('teg-component', true);
                location.href = `https://${subdomain}.${base}`;
            }
            return;
        }

        // SCLEN path — *.transporteg.com always redirects within that domain
        const SCLEN_URLS = {
            accounts: companyType === SEEKER_VALUE ? SEEKER_ACCOUNTS_URL : PROVIDER_ACCOUNTS_URL,
            indents: companyType === SEEKER_VALUE ? SEEKER_INDENT_URL : PROVIDER_INDENT_URL,
        };

        const redirectUrl = SCLEN_URLS[type];
        if (redirectUrl) {
            localStorage.setItem('teg-component', true);
            location.href = redirectUrl;
        }
    }



    handleOnClickForTransportationRequests = () => {
        const { history } = this.props;
        history.push('/contracting/generic/transportationRequests')
    }

    handleOnClickForsupplierDashboard = () => {
        const { history } = this.props;
        history.push('/contracting/generic/supplierDashboard')
    }

    handleOnClickForsupplierPO = () => {
        const { history } = this.props;
        history.push('/contracting/generic/orders/2');
    }

    shouldRenderTransportationRequests = () => {
        const C1 = isDesmet()
        const C2 = !isDesmetSupplier()
        if (C1 && C2) {
            return true
        }
        return false
    }
    shouldRenderBeamsReportsBlock = () => {
        if (isBeamS()) {
            return true;
        }
        return false;
    }
    shouldRenderBacardiReportsBlock = () => {
        if (isBacardi()) {
            return true;
        }
        return false;
    }
    shouldRenderCargilReportsBlock = () => {
        if (CARGIL.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderCenturyPlyReportsBlock = () => {
        if (CENTURY_PLY.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderABFRLReportsBlock = () => {
        if (isAbfrl()) {
            return true;
        }
        return false;
    }
    shouldRenderArdexReportsBlock = () => {
        if (ARDEX.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderSapDPLReportsBlock = () => {
        if (isSapDPL()) {
            return true;
        }
        return false;
    }
    shouldRenderFineTechReportsBlock = () => {
        if (isFineTech()) {
            return true;
        }
        return false;
    }

    shouldRenderHikalReportsBlock = () => {
        if (isHikal()) {
            return true;
        }
        return false;
    }
    shouldRenderFosrocReportsBlock = () => {
        if (isFosroc()) {
            return true;
        }
        return false;
    }
    shouldRenderNovateurReportsBlock = () => {
        if (LEGRAND_MIS.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderPolycabReportsBlock = () => {
        if (POLYCAB.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderRelianceBrandsReportsBlock = () => {
        if (RELIANCE_BRANDS.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderRelianceInfocomReportsBlock = () => {
        if (RIL_MIS.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderRelianceRetailReportsBlock = () => {
        if (RIL_RETAIL.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderADM_agroReportsBlock = () => {
        if (ADM_AGRO.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderADM_agroLaturReportsBlock = () => {
        if (ADM_AGRO_LATUR_VIZAG.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderGalaxySurfacantReportsBlock = () => {
        if (GALAXY_SURFACE.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderRajPetroSpecialtiesReportBlock = () => {
        if (RAJPETRO.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderTTBILReportsBlock = () => {
        if (TTBIL.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderRoquetteReportsBlock = () => {
        if (ROQUETTE.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderEmamiReportsBlock = () => {
        if (EMAMI.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderGreenplyReportsBlock = () => {
        if (GREEN_PLY.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderMahindraSummitReportsBlock = () => {
        if (MAHINDRA_SUMMIT.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderFreniusKabiReportsBlock = () => {
        if (FRESENIUS_KABI.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderKRBLReportsBlock = () => {
        if (KRBL.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderDalmiaReportsBlock = () => {
        if (DALMIA_CEMENT.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderCoromandelReportsBlock = () => {
        if (COROMANDEL.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderVishakaReportsBlock = () => {
        if (VISHAKA.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }
    shouldRenderGeneralContractingMISReport = () => {
        const company = [
            ...BACARDI,
            ...CARGIL,
            ...CENTURY_PLY,
            ...EMAMI,
            ...GREEN_PLY,
            ...KRBL,
            ...MUNDRA_SOLAR,
            ...ROQUETTE,
            ...STAR_CEMENT,
            ...FRESENIUS_KABI,
            ...GODREJ,
            ...MAHINDRA_SUMMIT,
            ...LEGRAND_MIS,
            ...PARAMOUNT,
            ...POLYCAB,
            ...RELIANCE_BRANDS,
            ...RIL_MIS,
            ...RIL_RETAIL,
            ...BHIWANDI_CYLINDERS,
            ...BAJAJ_ELECTRICALS,
            ...DALMIA_CEMENT,
            ...ADM_AGRO,
            ...ADM_AGRO_LATUR_VIZAG,
            ...GALAXY_SURFACE,
            ...RAJPETRO,
            ...TTBIL]
        if ((company).includes(this.user.companyId) || isSapDPL() || isFineTech()) {
            return true;
        }
        return false;
    }
    shouldRenderDesmetReportsBlock = () => {
        if (isDesmet()) {
            return true;
        }
        return false;
    }
    shouldRenderMitsuiReportsBlock = () => {
        if (isMITSUI()) {
            return true;
        }
        return false;
    }

    shouldRenderPantaloonsReportsBlock = () => {
        if (PANTALOONS.includes(this.user.companyId)) {
            return true;
        }
        return false;
    }

    getSecondaryContractLabel = () => {
        let sLabel = 'Secondary Contracts';
        if (isEmami()) {
            sLabel = 'Dedicated Contracts';
        }
        return sLabel;
    }

    handleOnClickForReport = (report_name) => {
        const { dispatch } = this.props;
        dispatch({
            type: SAVE_USER_REPORT_UTILIZATION_EVENT,
            payload: {
                event_name: "on_click_of_report",
                report_name: report_name
            },
        });
    }

    handleOnClickForTransportationManagement = () => {
        const { history } = this.props;
        history.push('/transportationManagement')
    }


    render() {
        const companyType = getCompanyType();
        const isApprover = getIsApprover();
        const user = getUser();
        console.log('user:', user.email)
        const { rfqStatusFilter, changeRfqStatusFilter, isMenuOpen, onMenuToggle, broadcastMsgs, history } = this.props;
        return (
            <div className={`sidebar flex-column flex-middle overflowAuto pb-150 ${broadcastMsgs.length > 0 ? 'top-155' : ''}`}>
                <div className="mt-5" />
                <div className={className("sidebar-item", {
                    'active': rfqStatusFilter == 2
                })}>
                    <span className="sidebar-item-icon">
                        <HomeIcon />
                    </span>
                    <span className="sidebar-item-text ml-10 fs-14 fBold">
                        Home
                    </span>
                </div>
                {/* <div className="separator" />
                <Link to="/admin" className={className("sidebar-item", { 'active': this.props.location && this.props.location.pathname === '/admin' })}>
                    <span className="sidebar-item-icon">
                        <ListIcon />
                    </span>
                    <span className="sidebar-item-text ml-10 fs-14 fBold">Admin</span>
                </Link> */}
                <div className="separator" />
                <div className={className("sidebar-item pr", {
                    'disable': !this.user.contracting
                })} >
                    <div onClick={() => this.collapseToggle("sourcing")} className="menu-header">
                        <a data-tip data-for='contract-source-tooltip'>
                            <span className="sidebar-item-icon">
                                <ListIcon />
                            </span>
                            <span className="sidebar-item-text ml-10 fs-14 fBold pr" >
                                Sourcing
                            </span>
                            <span className="collapse-button fs-14 pa fRegular" >
                                {
                                    !this.state.openSourcing && <span>+</span>
                                }
                                {
                                    this.state.openSourcing && <span>-</span>
                                }
                            </span>
                        </a>
                        {!this.user.contracting && <ReactTooltip id='contract-source-tooltip'>
                            <span className={'fBold'}>{MODULE_ERROR_ACCESS}</span><br />
                        </ReactTooltip>}
                    </div>
                    {
                        this.state.openSourcing && <ul className="side-bar-collapsable-list pl-20 fRegular pl-5">
                            <li className={className("fs-12 sub-menu-item", {
                                'active': rfqStatusFilter == 2
                            })} onClick={() => changeRfqStatusFilter(2)}>Active RFQS</li>
                            {companyType === SEEKER_VALUE && <li className={className("fs-12 sub-menu-item", {
                                'active': rfqStatusFilter == 1
                            })} onClick={() => changeRfqStatusFilter(1)}>RFQ Drafts</li>}
                            {<li className={className("fs-12 sub-menu-item", {
                                'active': rfqStatusFilter == 99
                            })} onClick={() => changeRfqStatusFilter(99)}>Cancelled RFQS</li>}
                            {companyType !== SEEKER_VALUE && <li className={className("fs-12 sub-menu-item", {
                                'active': rfqStatusFilter == 88
                            })} onClick={() => changeRfqStatusFilter(88)}>Service Category</li>}
                            {isApprover && <li className={className("fs-12 sub-menu-item", {
                                'active': rfqStatusFilter == 10
                            })} onClick={() => changeRfqStatusFilter(10)}>Pending Approval</li>}
                            {user.isDphApprover && <li className={className("fs-12 sub-menu-item", {
                                'active': rfqStatusFilter == 71
                            })} onClick={() => changeRfqStatusFilter(71)}>Pending DPH Approval</li>}
                            {
                                // companyType === SEEKER_VALUE &&
                                <li className={className("fs-12 sub-menu-item", {
                                })} onClick={() => {
                                    localStorage.setItem('teg-component', true);
                                    location.href = '/contractRecords'
                                }}>Contract Records</li>}
                            {companyType === SEEKER_VALUE && user.tK11Dashboard &&
                                <li className={className("fs-12 sub-menu-item", {
                                    'active': rfqStatusFilter == 11
                                })} onClick={() => changeRfqStatusFilter(11)}>TK 11 Dashboard</li>}
                            {companyType === SEEKER_VALUE && user.isCreateMasterData &&
                                <li className={className("fs-12 sub-menu-item", {
                                })} onClick={() => {
                                    localStorage.setItem('teg-component', true);
                                    location.href = '/routeMaster'
                                }}>Route Master</li>
                            }
                            {companyType === SEEKER_VALUE && isCoromandel() &&
                                < li className={className("fs-12 sub-menu-item", {
                                })} onClick={() => {
                                    localStorage.setItem('teg-component', true);
                                    location.href = '/dphDashboard'
                                }}>Dph Dashboard</li>
                            }

                        </ul>
                    }
                </div>
                {this.user.ammendmentLevel &&
                    <Fragment>
                        <div className="separator" />
                        <div className={className("sidebar-item pr")}>
                            <div className={className("menu-header", {
                                'active': rfqStatusFilter == 20
                            })} onClick={() => changeRfqStatusFilter(20)}>
                                <a data-tip data-for='approval-tooltip'>
                                    <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                        Approval
                                    </span>
                                </a>
                            </div>
                        </div>
                    </Fragment>}

                {DEEPAK_PHENOLICS.includes(this.user.companyId) &&
                    <Fragment>
                        <div className="separator" />
                        <div className={className("sidebar-item pr")}>
                            <div className={className("menu-header")}
                                onClick={() => {
                                    localStorage.setItem('teg-component', true);
                                    location.href = '/uploadPlan'
                                }}>
                                <a data-tip data-for='upload-tooltip'>
                                    <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                        Upload Plan
                                    </span>
                                </a>
                            </div>
                        </div>
                    </Fragment>}

                <div className="separator" />

                <div className={className("sidebar-item pr", {
                    'disable': !this.user.contracting
                })}>
                    <div onClick={() => this.collapseToggle("contracting")} className="menu-header">
                        <a data-tip data-for='contract-tenture-tooltip'>
                            <span className="sidebar-item-icon">
                                <ListIcon />
                            </span>
                            <span className="sidebar-item-text ml-10 fs-14 fBold pr" >
                                Contracting
                            </span>
                            <span className="collapse-button fs-14 pa fRegular" >
                                {
                                    !this.state.openContracting && <span>+</span>
                                }
                                {
                                    this.state.openContracting && <span>-</span>
                                }
                            </span>
                        </a>
                        {!this.user.contracting && <ReactTooltip id='contract-tenture-tooltip'>
                            <span className={'fBold'}>{MODULE_ERROR_ACCESS}</span><br />
                        </ReactTooltip>}
                    </div>
                    {
                        this.state.openContracting && <ul className="side-bar-collapsable-list pl-20 fRegular pl-5">
                            <li className={className("fs-12 sub-menu-item", {
                                'active': rfqStatusFilter == 6
                            })} onClick={() => changeRfqStatusFilter(6)}>Contracts</li>
                            <li className={className("fs-12 sub-menu-item", {
                                'active': rfqStatusFilter == 6
                            })} onClick={() => {
                                localStorage.setItem('teg-component', true);
                                window.location.href = LCL_URL + '/contracts'
                            }}>LCL</li>
                            {ABFRL.includes(user.companyId) &&
                                <li className={className("fs-12 sub-menu-item", {
                                })} onClick={() => {
                                    localStorage.setItem('teg-component', true);
                                    location.href = '/multiContracts'
                                }}>Multi Contracts</li>}
                            {([...PANTALOONS, ...CARGIL, ...ABFRL, ...DEEPAK_PHENOLICS_SAP, ...EMAMI].includes(user.companyId) || isAdaniWilmar()) &&
                                <li className={className("fs-12 sub-menu-item", {
                                })} onClick={() => {
                                    localStorage.setItem('teg-component', true);
                                    location.href = '/secondaryContracts'
                                }}>{this.getSecondaryContractLabel()}</li>}
                            <div onClick={() => {
                                const { openMultiModeContracts } = this.state;
                                this.setState({ openMultiModeContracts: !openMultiModeContracts });
                            }} className="menu-header mt-5 mb-5">
                                <span className="sidebar-item-text ml-10 fs-12 pr" >
                                    Multi Mode Contracts
                                </span>
                                <span className="collapse-button fs-14 pa fRegular" >
                                    {
                                        !this.state.openMultiModeContracts && <span>+</span>
                                    }
                                    {
                                        this.state.openMultiModeContracts && <span>-</span>
                                    }
                                </span>
                            </div>
                            {this.state.openMultiModeContracts && <>
                                <li className="sub-menu-item"><Link to="/multiModeContracts" className="fs-12 ml-10">
                                    Generate Contracts
                                </Link></li>
                                <li className="sub-menu-item"><Link to="/viewGeneratedContracts" className="fs-12 ml-10">
                                    View Generated Contracts
                                </Link></li>
                            </>}

                            {isAdaniWilmar() &&
                                <li className={className("fs-12 sub-menu-item", {
                                    'active': rfqStatusFilter == 21
                                })} onClick={() => {
                                    localStorage.setItem('teg-component', true);
                                    window.location.href = '/awlMISReports'
                                }}>Reports</li>}
                            {isAdaniWilmar() &&
                                <li className={className("fs-12 sub-menu-item", {
                                    // 'active': rfqStatusFilter == 21
                                })} onClick={() => {
                                    localStorage.setItem('teg-component', true);
                                    window.location.href = '/dashboards'
                                }}>Dashboards</li>}

                        </ul>
                    }
                </div>
                <div className="separator" />
                {
                    // <div className="sidebar-item pr" >
                    //     <div onClick={() => this.collapseToggle("contracting")} className="menu-header">
                    //         <span className="sidebar-item-icon">
                    //             <ListIcon />
                    //         </span>
                    //         <span className="sidebar-item-text ml-10 fs-14 fBold pr" >
                    //             TRACKING
                    //         </span>
                    //     </div>
                    // </div>   
                    // <div className="separator" />
                }
                {SHOW_SIDEBAR && companyType === SEEKER_VALUE && EMAMI.includes(user.companyId) && <React.Fragment> <div className={className("sidebar-item pr", {
                    'disable': !this.user.contracting
                })} >
                    <div onClick={() => {
                        localStorage.setItem('teg-component', true);
                        window.location.href = '/eventManagement'
                    }} className="menu-header">
                        <a data-tip data-for='pr-tracking-tooltip'>
                            <span className="sidebar-item-text ml-10 fs-14 fBold pr" >
                                Event Management
                            </span>
                        </a>
                        {!this.user.contracting && <ReactTooltip id='pr-tracking-tooltip'>
                            <span className={'fBold'}>{MODULE_ERROR_ACCESS}</span><br />
                        </ReactTooltip>}
                    </div>
                </div>
                    <div className="separator" /></React.Fragment>
                }

                {SHOW_SIDEBAR && companyType === SEEKER_VALUE && isAdaniWilmar() && <React.Fragment> <div className={className("sidebar-item pr", {
                    'disable': !this.user.contracting
                })} >
                    <div onClick={() => {
                        localStorage.setItem('teg-component', true);
                        history.push('/multimodalRateComparison')
                    }} className="menu-header">
                        <a data-tip data-for='pr-tracking-tooltip'>
                            <span className="sidebar-item-text ml-10 fs-14 fBold pr" >
                                Multimodal Comparison
                            </span>
                        </a>
                        {!this.user.contracting && <ReactTooltip id='pr-tracking-tooltip'>
                            <span className={'fBold'}>{MODULE_ERROR_ACCESS}</span><br />
                        </ReactTooltip>}
                    </div>
                </div>
                    <div className="separator" /></React.Fragment>
                }
                {<React.Fragment><div className={className("sidebar-item pr", {
                        'disable': !this.user.indenting
                    })}  >
                        <div onClick={() => this.handleAccountsRedirect("indents")} className="menu-header">
                            <a data-tip data-for='indenting-tooltip'>
                                <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                    Indenting
                                </span>
                            </a>
                            {!this.user.indenting && <ReactTooltip id='indenting-tooltip'>
                                <span className={'fBold'}>{MODULE_ERROR_ACCESS}</span><br />
                            </ReactTooltip>}
                            {
                                //     <span className="collapse-button fs-14 pa fRegular" >
                                //         {
                                //             !this.state.openIndenting && <span>+</span>
                                //         }
                                //         {
                                //             this.state.openIndenting && <span>-</span>
                                //         }
                                //     </span>
                            }
                        </div>

                        {
                            //     this.state.openIndenting && <ul className="side-bar-collapsable-list pl-20 fRegular">
                            //         <li className="fs-12">Active RFQS</li>
                            //         {companyType === SEEKER_VALUE &&<li className="fs-12">RFQ DRAFTS</li>}
                            //         {companyType === SEEKER_VALUE &&<li className="fs-12">CLOSED RFQS</li>}
                            //         <li className="fs-12">CONTRACTS</li>
                            //     </ul>
                        }
                    </div>
                        <div className="separator" /></React.Fragment>
                }

                {this.shouldRenderTransportationRequests() && <SiderBarElementT1
                    title={"Transportation Requests"}
                    handleOnClick={this.handleOnClickForTransportationRequests}
                />}

                {isDesmetSupplier() && <SiderBarElementT1
                    title={"Supplier Dashboard"}
                    handleOnClick={this.handleOnClickForsupplierDashboard}
                />}

                {this.shouldRenderTransportationRequests() && <SiderBarElementT1
                    title={"Supplier PO"}
                    handleOnClick={this.handleOnClickForsupplierPO}
                />}

                {TTBIL.includes(user.companyId) && <SiderBarElementT1
                    title={"Transportation Management"}
                    handleOnClick={this.handleOnClickForTransportationManagement}
                />}

                {<React.Fragment> <div className={className("sidebar-item pr", {
                        'disable': !this.user.accounts
                    })} >
                        <div onClick={() => this.handleAccountsRedirect("accounts")} className="menu-header">
                            <a data-tip data-for='accounts-tooltip'>
                                <span className="sidebar-item-text ml-10 fs-14 fBold pr" >
                                    Accounts
                                </span>
                            </a>
                            {!this.user.accounts && <ReactTooltip id='accounts-tooltip'>
                                <span className={'fBold'}>{MODULE_ERROR_ACCESS}</span><br />
                            </ReactTooltip>}
                        </div>
                    </div>
                        <div className="separator" /></React.Fragment>
                }

                {SHOW_SIDEBAR && [...HIKAL, ...BEAM].includes(user.companyId) && <React.Fragment> <div className={className("sidebar-item pr")} >
                    <div onClick={() => {
                        localStorage.setItem('teg-component', true);
                        if (isBeamS()) {   // not gave any approval , move code to prod ( if you want to use this feature please remove false )
                            history.push('/EXIMCargoTracking')
                        } else {
                            history.push('/cargoTracking')
                        }
                    }} className="menu-header">
                        <a data-tip data-for='accounts-tooltip'>
                            <span className="sidebar-item-text ml-10 fs-14 fBold pr" >
                                EXIM Cargo Tracking
                            </span>
                        </a>
                        {/* {!this.user.accounts && <ReactTooltip id='accounts-tooltip'>
                                    <span className={'fBold'}>{MODULE_ERROR_ACCESS}</span><br />
                            </ReactTooltip>} */}
                    </div>
                </div>
                    <div className="separator" /></React.Fragment>
                }

                {getIsSettingsVisible() && <div className={className("sidebar-item pr", {
                    'disable': !this.user.contracting
                })}  >
                    <div onClick={() => this.collapseToggle("settings")} className="menu-header">
                        <a data-tip data-for='contract-settings-tooltip'>
                            <span className="sidebar-item-icon">
                                <ListIcon />
                            </span>
                            <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                Settings
                            </span>
                            <span className="collapse-button fs-14 pa fRegular" >
                                {
                                    !this.state.openSettings && <span>+</span>
                                }
                                {
                                    this.state.openSettings && <span>-</span>
                                }
                            </span>
                        </a>
                        {!this.user.contracting && <ReactTooltip id='contract-settings-tooltip'>
                            <span className={'fBold'}>{MODULE_ERROR_ACCESS}</span><br />
                        </ReactTooltip>}
                    </div>
                    {
                        this.state.openSettings && <ul className="side-bar-collapsable-list pl-20 fRegular">
                            {companyType === SEEKER_VALUE &&
                                <Fragment>
                                    <li className="fs-12">
                                        <Link to="/groups/2" className="fs-12">TRANSPORTATION GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/8" className="fs-12">AGGREGATORS GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/9" className="fs-12">SURVEYORS GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/10" className="fs-12">LASHERS GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/21" className="fs-12">HANDLING AGENTS GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/22" className="fs-12">SHIPPING LINERS GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/24" className="fs-12">BUYERS GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/13" className="fs-12">CHA GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/14" className="fs-12">CFS GROUP</Link>
                                    </li>
                                    <li className="fs-12">
                                        <Link to="/groups/27" className="fs-12">FREIGHT FORWARDER GROUP</Link>
                                    </li>
                                </Fragment>
                            }
                            {VISHAKA.includes(this.user.companyId) &&
                                <li className="fs-12">
                                    <Link to="/cityMappingMaster" className="fs-12">City Mapping Master</Link>
                                </li>
                            }
                        </ul>
                    }

                </div>}
                {getIsSettingsVisible() && <div className="separator" />}
                {!isAdaniWilmar() &&
                    // companyType === SEEKER_VALUE && 
                    <div className={className("sidebar-item pr", {
                        'disable': !this.user.reports
                    })} >
                        {this.user.reports ? <div onClick={() => this.collapseToggle("reports")} className="menu-header">
                            <span className="sidebar-item-icon">
                                <ListIcon />
                            </span>
                            <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                Reports
                            </span>
                            <span className="collapse-button fs-14 pa fRegular" >
                                {
                                    !this.state.openReports && <span>+</span>
                                }
                                {
                                    this.state.openReports && <span>-</span>
                                }
                            </span>
                        </div>
                            :
                            <div className="menu-header">
                                <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                    Reports
                                </span>
                            </div>
                        }

                        {
                            this.state.openReports &&
                            <ul className="side-bar-collapsable-list pl-20 mb-50 fRegular">
                                {companyType === SEEKER_VALUE &&
                                    <React.Fragment>
                                        {this.shouldRenderGeneralContractingMISReport() &&
                                            <>
                                                <Link
                                                    to="/holistics"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Contracting MIS')
                                                    }}
                                                >
                                                    <li className="fs-12">Contracting MIS</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderABFRLReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/indentmis"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Indent MIS')
                                                    }}
                                                >
                                                    <li className="fs-12"> Indent MIS</li>
                                                </Link>
                                                {/* <Link to="/report/91" className='fs-12'>
                                        <li className='fs-12'>ABFRL - DPH Rate Report</li>
                                        </Link>
                                        <Link to="/report/92" className='fs-12'>
                                        <li className='fs-12'>ABFRL - Integrations API Call Logging</li>
                                        </Link>
                                        <Link to="/report/93" className='fs-12'>
                                        <li className='fs-12'>ABFRL FTL dedicated trips</li>
                                        </Link> */}
                                            </>
                                        }
                                        {this.shouldRenderArdexReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/report/209"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('ARDEX - CONTRACT MIS')
                                                    }}
                                                >
                                                    <li className="">ARDEX - CONTRACT MIS</li>
                                                </Link>
                                                <Link
                                                    to="/transporterParticipation"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Transporter Participation')
                                                    }}
                                                >
                                                    <li className="">Transporter Participation</li>
                                                </Link>

                                                <Link
                                                    to="/gDashboard/4a4bd828e8b947a19ef0ae75b477ce9b"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('ARDEX ENDURA - CONTRACT MONITORING DASHBOARD')
                                                    }}
                                                >
                                                    <li className="">ARDEX ENDURA - CONTRACT MONITORING DASHBOARD</li>
                                                </Link>
                                                <Link
                                                    to="/gDashboard/6e8337611e494282845fb4de11bfb07b"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('ARDEX ENDURA - PRICE TREND DASHBOARD')
                                                    }}
                                                >
                                                    <li className="">ARDEX ENDURA - PRICE TREND DASHBOARD</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderBacardiReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/report/85"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Delivery Within Validity')
                                                    }}
                                                >
                                                    <li className='fs-12'>Delivery Within Validity</li>
                                                </Link>
                                                <Link
                                                    to="/gDashboard/0dc2ba39899949759d77cd2855a7ecfb"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('BACARDI  - CONTRACT MONITORIING DASHBOARD')
                                                    }}
                                                >
                                                    <li className='fs-12'>BACARDI  - CONTRACT MONITORIING DASHBOARD</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderCargilReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/gDashboard/6f7f1693574c4ec2ac54ed35aa50c6da9922"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Contracting Dashboard')
                                                    }}
                                                >
                                                    <li className="fs-12"> Contracting Dashboard</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderCenturyPlyReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/gDashboard/6f7f1693574c4ec2ac54ed35aa50c6da9935"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Contract Monitoring Dashboard')
                                                    }}
                                                >
                                                    <li className="fs-12">Contract Monitoring Dashboard</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderSapDPLReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/report/123"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('DPL - DIESEL PRICE HIKE REPORT')
                                                    }}
                                                >
                                                    <li className='fs-12'>DPL - DIESEL PRICE HIKE REPORT</li>
                                                </Link>
                                                <Link
                                                    to="/report/124"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('DPL - TRANSPORTER PARTICIPATION REPORT')
                                                    }}
                                                >
                                                    <li className='fs-12'>DPL - TRANSPORTER PARTICIPATION REPORT</li>
                                                </Link>
                                                <Link
                                                    to="/gDashboard/6f7f1693574c4ec2ac54ed35aa50c6da9916"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Contracting Dashboard')
                                                    }}
                                                >
                                                    <li className="fs-12"> Contracting Dashboard</li>
                                                </Link>
                                                <Link
                                                    to="/gDashboard/6f7f1693574c4ec2ac54ed35aa50c6da9954"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('DPL - NEW Contract Monitoring Dashboard')
                                                    }}
                                                >
                                                    <li className='fs-12'>DPL - NEW Contract Monitoring Dashboard</li>
                                                </Link>
                                                <Link
                                                    to="/report/172"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('DPL - USER DETAILS')
                                                    }}
                                                >
                                                    <li className='fs-12'>DPL - USER DETAILS</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderEmamiReportsBlock() &&
                                            <>
                                                {/* <Link to="/report/53" className="fs-12">
                                        <li className="fs-12"> Contracting Summary Report</li>
                                        </Link> */}
                                                <Link
                                                    to="/gDashboard/6f7f1693574c4ec2ac54ed35aa50c6da9927"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Contract Monitoring Dashboard')
                                                    }}
                                                >
                                                    <li className="fs-12">Contract Monitoring Dashboard</li>
                                                </Link>
                                                <Link
                                                    to="/gDashboard/10f096df9705476ea1cf3152d6ba9997"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Emami Contract Monitoring Dashboard(N)')
                                                    }}
                                                >
                                                    <li className="fs-12">Emami Contract Monitoring Dashboard(N)</li>
                                                </Link>
                                                <Link
                                                    to="/indentmis"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Indent MIS')
                                                    }}
                                                >
                                                    <li className="fs-12"> Indent MIS</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderGreenplyReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/report/28"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Transporter Participation')
                                                    }}
                                                >
                                                    <li className="">Transporter Participation</li>
                                                </Link>
                                                <Link
                                                    to="/report/196"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('GREENPLY - CONTRACT MIS')
                                                    }}
                                                >
                                                    <li className="">GREENPLY - CONTRACT MIS</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderKRBLReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/report/49"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Customized Contracting Report')
                                                    }}
                                                >
                                                    <li className='fs-12'>Customized Contracting Report</li>
                                                </Link>
                                            </>
                                        }

                                        {this.shouldRenderFreniusKabiReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/report/203"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('KABI - CONTRACT MIS')
                                                    }}
                                                >
                                                    <li className='fs-12'>KABI - CONTRACT MIS</li>
                                                </Link>
                                                <Link
                                                    to="/gDashboard/3135003c3c2e456ba4ac7786ffed64b6"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('KABI - CONTRACT MONITORING DASHBOARDD')
                                                    }}
                                                >
                                                    <li className='fs-12'>KABI - CONTRACT MONITORING DASHBOARDD</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderMahindraSummitReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/report/201"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('MAHINDRA SUMMIT - CONTRACT MIS')
                                                    }}
                                                >
                                                    <li className='fs-12'>MAHINDRA SUMMIT - CONTRACT MIS</li>
                                                </Link>
                                                <Link
                                                    to="/gDashboard/c627c7888ede440c99f42f7eaa2e5366"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('MAHINDRA SUMMIT - CONTRACT MONITORING DASHBOARD')
                                                    }}
                                                >
                                                    <li className='fs-12'>MAHINDRA SUMMIT - CONTRACT MONITORING DASHBOARD</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderRoquetteReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/report/45"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Gokak Plant - MIS')
                                                    }}
                                                >
                                                    <li className="fs-12"> Gokak Plant - MIS</li>
                                                </Link>
                                                <Link
                                                    to="/report/46"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Pantnagar Plant - MIS')
                                                    }}
                                                >
                                                    <li className="fs-12"> Pantnagar Plant - MIS</li>
                                                </Link>
                                                <Link
                                                    to="/report/47"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Viramgam Plant - MIS')
                                                    }}
                                                >
                                                    <li className="fs-12"> Viramgam Plant - MIS</li>
                                                </Link>
                                                <Link
                                                    to="/report/140"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('ROQUETTE - SUMMARY REPORT')
                                                    }}
                                                >
                                                    <li className="fs-12">ROQUETTE - SUMMARY REPORT</li>
                                                </Link>
                                                <Link
                                                    to="/report/141"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Roquette - CONTRACT MIS (Lane Wise)')
                                                    }}
                                                >
                                                    <li className="fs-12">Roquette - CONTRACT MIS (Lane Wise)</li>
                                                </Link>
                                                <Link
                                                    to="/report/142"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Roquette - Savings Report')
                                                    }}
                                                >
                                                    <li className="fs-12">Roquette - Savings Report</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderFineTechReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/transporterParticipation"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Transporter Participation')
                                                    }}
                                                >
                                                    <li className="">Transporter Participation</li>
                                                </Link>
                                                <Link
                                                    to="/report/122"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Allocation Report')
                                                    }}
                                                >
                                                    <li className='fs-12'>Allocation Report</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderFosrocReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/report/137"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('FOSROC - CONTRACT MIS')
                                                    }}
                                                >
                                                    <li className='fs-12'>FOSROC - CONTRACT MIS</li>
                                                </Link>
                                            </>
                                        }

                                        {this.shouldRenderHikalReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/report/136"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('HIKAL - CONTRACT MIS')
                                                    }}
                                                >
                                                    <li className='fs-12'>HIKAL - CONTRACT MIS</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderNovateurReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/managementSummarReport"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Management Summary Report')
                                                    }}
                                                >
                                                    <li className="fs-12">Management Summary Report</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderPolycabReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/transporterParticipation"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Transporter Participation')
                                                    }}
                                                >
                                                    <li className="">Transporter Participation</li>
                                                </Link>

                                                <Link
                                                    to="/report/200"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('POLYCAB - CONTRACT MIS')
                                                    }}
                                                >
                                                    <li className="">POLYCAB - CONTRACT MIS</li>
                                                </Link>

                                                <Link
                                                    to="/gDashboard/eb3935a60c904f2fb0f28badf9f0999b"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('POLYCAB - CONTRACT MONITORING DASHBOARD')
                                                    }}
                                                >
                                                    <li className="">POLYCAB - CONTRACT MONITORING DASHBOARD</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderRelianceBrandsReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/transporterParticipation"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Transporter Participation')
                                                    }}
                                                >
                                                    <li className="">Transporter Participation</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderRelianceInfocomReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/transporterParticipation"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Transporter Participation')
                                                    }}
                                                >
                                                    <li className="">Transporter Participation</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderRelianceRetailReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/transporterParticipation"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Transporter Participation')
                                                    }}
                                                >
                                                    <li className="">Transporter Participation</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderADM_agroReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/transporterParticipation"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Transporter Participation')
                                                    }}
                                                >
                                                    <li className="">Transporter Participation</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderADM_agroLaturReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/transporterParticipation"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Transporter Participation')
                                                    }}
                                                >
                                                    <li className="">Transporter Participation</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderGalaxySurfacantReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/transporterParticipation"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Transporter Participation')
                                                    }}
                                                >
                                                    <li className="">Transporter Participation</li>
                                                </Link>

                                                <Link
                                                    to="/report/202"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('GALAXY SURFACTANTS - CONTRACT MIS')
                                                    }}
                                                >
                                                    <li className="fs-12">GALAXY SURFACTANTS - CONTRACT MIS</li>
                                                </Link>
                                                <Link
                                                    to="/gDashboard/62787d9aceda410aba4ffea1e9372fc3"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('GALAXY SURFACTANTS - CONTRACT MONITORING DASHBOARD')
                                                    }}
                                                >
                                                    <li className="fs-12">GALAXY SURFACTANTS - CONTRACT MONITORING DASHBOARD</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderRajPetroSpecialtiesReportBlock() &&
                                            <>
                                                <Link
                                                    to="/transporterParticipation"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Transporter Participation')
                                                    }}
                                                >
                                                    <li className="">Transporter Participation</li>
                                                </Link>
                                                <Link
                                                    to="/gDashboard/6f7f1693574c4ec2ac54ed35aa50c6da9971"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Raj Petro Contract Monitoring Dashboard')
                                                    }}
                                                >
                                                    <li className="">Raj Petro Contract Monitoring Dashboard</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderTTBILReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/transporterParticipation"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Transporter Participation')
                                                    }}
                                                >
                                                    <li className="">Transporter Participation</li>
                                                </Link>
                                                <Link
                                                    to="/endtoendmis"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('End To End MIS')
                                                    }}
                                                >
                                                    <li className="fs-12">End To End MIS</li>
                                                </Link>
                                                <Link
                                                    to="/indentmis"
                                                    className="fs-12"
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Indent MIS')
                                                    }}
                                                >
                                                    <li className="fs-12"> Indent MIS</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderBeamsReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/report/103"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('BEAMS Contract MIS')
                                                    }}
                                                >
                                                    <li className='fs-12'>BEAMS Contract MIS</li>
                                                </Link>
                                                <Link
                                                    to="/report/171"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('MILESTONE TRACKING REPORT')
                                                    }}
                                                >
                                                    <li className='fs-12'>MILESTONE TRACKING REPORT</li>
                                                </Link>
                                                <Link
                                                    to="/report/165"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('EXIM - TRANSPORTER CONTRACT MIS')
                                                    }}
                                                >
                                                    <li className='fs-12'>EXIM - TRANSPORTER CONTRACT MIS</li>
                                                </Link>
                                                <Link
                                                    to="/report/167"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('EXIM - CHA CONTRACT MIS')
                                                    }}
                                                >
                                                    <li className='fs-12'>EXIM - CHA CONTRACT MIS</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderDesmetReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/report/154"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('DESMET - CONTRACT MIS')
                                                    }}
                                                >
                                                    <li className='fs-12'>DESMET - CONTRACT MIS</li>
                                                </Link>
                                                <Link
                                                    to="/report/221"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('DESMET - PURCHASE ORDERS')
                                                    }}
                                                >
                                                    <li className='fs-12'>Desmet Purchase Orders</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderMitsuiReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/report/195"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('MITSUI - CONTRACT MIS')
                                                    }}
                                                >
                                                    <li className='fs-12'>MITSUI - CONTRACT MIS</li>
                                                </Link>

                                                <Link
                                                    to="/gDashboard/8611e626d7f545c6abdb9a516998c682"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('MITSUI - CONTRACT MONITORING DASHBOARDD')
                                                    }}
                                                >
                                                    <li className='fs-12'>MITSUI - CONTRACT MONITORING DASHBOARDD</li>
                                                </Link>
                                            </>
                                        }

                                        {this.shouldRenderPantaloonsReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/report/190"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('Secondary Contract MIS')
                                                    }}
                                                >
                                                    <li className='fs-12'>Secondary Contract MIS</li>
                                                </Link>
                                            </>
                                        }

                                        {this.shouldRenderDalmiaReportsBlock() &&

                                            <>
                                                {user.email == "yadav.amitkumar@dalmiacement.com" &&
                                                    <Link
                                                        to="/gDashboard/6f7f1693574c4ec2ac54ed35aa50c6da9972"
                                                        className='fs-12'
                                                        onClick={() => {
                                                            this.handleOnClickForReport('Dalmia - System Suggested Price Prediction (Top10 Routes)')
                                                        }}
                                                    >
                                                        <li className='fs-12'>Dalmia - System Suggested Price Prediction (Top10 Routes)</li>
                                                    </Link>
                                                }
                                            </>
                                        }
                                        {this.shouldRenderCoromandelReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/report/198"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('COROMANDEL - CONTRACT MIS')
                                                    }}
                                                >
                                                    <li className='fs-12'>COROMANDEL - CONTRACT MIS</li>
                                                </Link>
                                            </>
                                        }
                                        {this.shouldRenderVishakaReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/report/214"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('VISHAKHA - CONTRACT MIS_FTL_V1.0.1')
                                                    }}
                                                >
                                                    <li className='fs-12'>VISHAKHA - CONTRACT MIS_FTL_V1.0.1</li>
                                                </Link>
                                            </>
                                        }
                                    </React.Fragment>
                                }
                                {companyType !== SEEKER_VALUE &&
                                    this.state.DaaiReports.map((report) => (
                                        <Link
                                            key={report.type}
                                            to={`/report/${report.type}`}
                                            className='fs-12'
                                            onClick={() => {
                                                this.handleOnClickForReport(report.name)
                                            }}
                                        >
                                            <li className='fs-12'>{report.name}</li>
                                        </Link>
                                    ))
                                }
                            </ul>
                        }
                    </div>}
                {ROQUETTE.includes(this.user.companyId) && //for now only roquette has this seperate segregation as a dashboard later feel free to make generic
                    <div className={className("sidebar-item pr", {
                        'disable': !this.user.reports
                    })} >
                        {this.user.reports ? <div onClick={() => this.collapseToggle("dashboards")} className="menu-header">
                            <span className="sidebar-item-icon">
                                <ListIcon />
                            </span>
                            <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                Dashboards
                            </span>
                            <span className="collapse-button fs-14 pa fRegular" >
                                {
                                    !this.state.openDashboards && <span>+</span>
                                }
                                {
                                    this.state.openDashboards && <span>-</span>
                                }
                            </span>
                        </div>
                            :
                            <div className="menu-header">
                                <span className="sidebar-item-text ml-10 fs-14 fBold pr">
                                    Dashboards
                                </span>
                            </div>
                        }

                        {
                            this.state.openDashboards &&
                            <ul className="side-bar-collapsable-list pl-20 mb-50 fRegular">
                                {companyType === SEEKER_VALUE &&
                                    <React.Fragment>
                                        {this.shouldRenderRoquetteReportsBlock() &&
                                            <>
                                                <Link
                                                    to="/gDashboard/6f7f1693574c4ec2ac54ed35aa50c6da9962"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('CONTRACTING DASHBOARD')
                                                    }}
                                                >
                                                    <li className='fs-12'>CONTRACTING DASHBOARD</li>
                                                </Link>
                                                <Link
                                                    to="/gDashboard/6f7f1693574c4ec2ac54ed35aa50c6da9963"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('CONTRACT MOINTORING DASHBOARD')
                                                    }}
                                                >
                                                    <li className='fs-12'>CONTRACT MOINTORING DASHBOARD</li>
                                                </Link>
                                                <Link
                                                    to="/gDashboard/6f7f1693574c4ec2ac54ed35aa50c6da9964"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('SAVINGS DASHBOARD (TRANSPORTERS)')
                                                    }}
                                                >
                                                    <li className='fs-12'>SAVINGS DASHBOARD (TRANSPORTERS)</li>
                                                </Link>
                                                {/* <Link
                                                    to="/gDashboard/95e60e5a079e4c6cafa438e5d502bb3f"
                                                    className='fs-12'
                                                    onClick={() => {
                                                        this.handleOnClickForReport('ROQUETTE - PTPK ANALYSIS DASHBOARD')
                                                    }}
                                                >
                                                    <li className='fs-12'>ROQUETTE - PTPK ANALYSIS DASHBOARD</li>
                                                </Link> */}
                                            </>
                                        }
                                    </React.Fragment>
                                }

                            </ul>
                        }
                    </div>}
                
            </div>
        )
    }
}

export default connect(null, null)(withRouter(Sidebar));
